









'use strict';

var FlattenStyle={
current:function current(style){return style;},
inject:function inject(flatten){
FlattenStyle.current=flatten;
}};


module.exports=FlattenStyle;


//////////////////
// WEBPACK FOOTER
// ./~/animated/lib/injectable/FlattenStyle.js
// module id = 165
// module chunks = 0